/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react"
import { type FC } from "react"
import { AccountMenu, FeedbackButton } from "./RunHeader"

/**
 * Icon-only account/feedback controls for chromeless pages — a full-bleed embed
 * (e.g. the digital twin) suppresses the tall RunHeader to reclaim vertical
 * space, but still needs the account menu (which also carries the light/dark
 * toggle) and the feedback trigger. Unlike the RunHeader this reserves NO row of
 * its own: it overlays the page content's top-right corner, and the embed is
 * told (via the adapter's hostControlsInsetPx) to shift its own toolbar left so
 * both control sets share the embed's single header row. Any route with
 * `handle: { chrome: "slim" }` gets this — see DashboardLayout.
 */

/** Width (px) of the corner strip the overlay occupies: two ~32px icon buttons
 *  plus the right offset and a breathing gap. Passed to the embed as
 *  hostControlsInsetPx so its toolbar stops left of the overlay. */
export const SLIM_HEADER_CONTROLS_INSET_PX = 64

const slimStyles = {
  bar: css`
    position: absolute;
    /* Vertically centers the 24px icons on the embed's ~30px toolbar row,
       which sits 0.5rem below the iframe top. */
    top: 0.7rem;
    right: 0.75rem;
    z-index: 20;
    display: flex;
    align-items: center;
  `,
}

interface SlimHeaderProps {
  onSendFeedback?: () => void
}

export const SlimHeader: FC<SlimHeaderProps> = ({ onSendFeedback }) => (
  <div css={slimStyles.bar}>
    <AccountMenu />
    <FeedbackButton onSendFeedback={onSendFeedback} />
  </div>
)
